import { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  // Always dark mode
  const isDark = true;

  // Apply dark mode immediately on mount
  useEffect(() => {
    if (typeof document === 'undefined') return;
    document.documentElement.classList.add('dark');
    // Remove any light mode preference from localStorage
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem('theme');
    }
  }, []);

  return (
    <ThemeContext.Provider value={{ isDark }}>
      {children}
    </ThemeContext.Provider>
  );
};
